var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftEnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.79723 0.229221C9.52687 -0.0764069 9.08852 -0.0764069 8.81816 0.229221L4.20277 5.44661C3.93241 5.75224 3.93241 6.24776 4.20277 6.55339L8.81816 11.7708C9.08852 12.0764 9.52687 12.0764 9.79723 11.7708C10.0676 11.4652 10.0676 10.9696 9.79723 10.664L5.67138 6L9.79723 1.336C10.0676 1.03037 10.0676 0.534848 9.79723 0.229221Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.75C0 0.335786 0.335786 0 0.75 0C1.16421 0 1.5 0.335786 1.5 0.75V11.25C1.5 11.6642 1.16421 12 0.75 12C0.335786 12 0 11.6642 0 11.25V0.75Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftEnd);
export default __webpack_public_path__ + "static/media/arrow-left-end.b2564098cece6e0a23e5d389da19d785.svg";
export { ForwardRef as ReactComponent };